import { createSlice } from "@reduxjs/toolkit";

export const orgSlice = createSlice({
  name: "org",
  initialState: {
    value: false,
  },
  reducers: {
    setOrg: (state, sel) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value = sel;
    }
  },
});

// Action creators are generated for each case reducer function
export const { setOrg } = orgSlice.actions;

export default orgSlice.reducer;
